# message values are tenant-supplied, so they must be escaped before being
# trusted as HTML: this filter renders in the operator/master admin consoles.
escapeHtml = (str) ->
  String(str)
    .replace /&/g, '&amp;'
    .replace /"/g, '&quot;'
    .replace /'/g, '&#39;'
    .replace /</g, '&lt;'
    .replace />/g, '&gt;'

angular.module 'zc.core'

.filter "showElement", ($sce) ->
  (message, column) ->
    value = message[column.name]
    if value
      escaped = escapeHtml value
      html = switch column.type
        when "image" then "<div><image src=\"#{escaped}\"></div>"
        when "color" then "<div><div style=\"background-color:#{escaped}; width: 24px; height:24px; display:inline-block\"></div> <span>#{escaped}</span></div>"
        when "url"
          # escaping does not stop javascript: URLs, so only link http(s)
          if /^https?:\/\//i.test(String(value))
            "<div style=\"background-color:#{escaped};\"><a href=\"#{escaped}\" target=\"_blank\">#{escaped}</a></div>"
          else
            "<div>#{escaped}</div>"
        when "duration" then "<div>#{escaped}min</div>"
        else "<div>#{escaped}</div>"
      $sce.trustAsHtml html
    else
      "empty"



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/filters/show_element.filter.coffee